<template>
  <div class="simple-layout min-h-screen flex flex-col">
    <header>
      <div class="max-w-xlg w-full mx-auto flex p-4 justify-center">
        <NuxtLink
          :to="getLocalizedRoute(Routes.Index)"
          :class="{
            'lg:my-[18px]': isNoriuLive || isTarpininke,
          }">
          <img
            :src="isNoriuLive ? logos.logoWhite : logos.logo"
            class="logo dark:invert"
            :class="{
              'min-w-[219px] max-w-[219px]': !isTarpininke,
              'min-h-[65px] min-w-[90px]': isTarpininke,
            }"
            alt="Logo" />
        </NuxtLink>
      </div>
    </header>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { Routes } from '~/enums/Routes'
const { isTarpininke, isNoriuLive } = useTheme()

const logos = await useAssetManager().getLogos()
</script>

<style lang="scss" scoped>
header {
  border-bottom: 1px solid theme('colors.neutral6');
  background-color: theme('colors.white');
  width: 100%;

  @apply dark:bg-dmGray1;
}

.alt header {
  border-bottom: 1px solid theme('colors.neutral6');
  background-color: theme('colors.brand.primary');
}

.nl header {
  border-bottom: 1px solid theme('colors.brown');
  background-color: theme('colors.brand.primary');
}
.wl header {
  border-bottom: 1px solid theme('colors.brand.primary');
  background-color: theme('colors.white');
}
</style>
